export const defaultFilter = {
  access: [],
  type: [],
  level: [],
  coach: [],
  subjects: [],
  sortBy: false,
  hasSeries: null
};
